import { useState } from "react";
import Cookies from "js-cookie";
import AuthenticationContext from "./AuthenticationContext";
import { useEffect } from "react";
import toast from "react-hot-toast";
import useAxios from "../services/useAxios";
import Loader from "../utils/Loader";
import { strict } from "assert";
import { type } from "@testing-library/user-event/dist/type";

// admin access level: [5, 7, 8, 9, 10, 11, 12]
// customer access level : [13,14,15,16]
interface UserInformation {
  token: string;
  fullName: string;
  mobile: number;
  userRoll: any[];
  id: any;
}
export default function Authentication({
  children,
}: {
  children: JSX.Element;
}) {
  const { execute: CheckLoginInfoAPI } = useAxios("api/checklogininfo");

  const [userInfo, setUserInfo] = useState<UserInformation>({
    token: "",
    fullName: "",
    mobile: 0,
    userRoll: [],
    id: null,
  });

  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);

  useEffect(() => {
    checkCookie();
  }, []);

  function login(
    token: string,
    fullName: string,
    mobile: number,
    userRoll: any[],
    id: any
  ): void {
    if (token) {
      setUserInfo({
        token,
        fullName,
        mobile,
        userRoll,
        id: id,
      });

      setIsLogged(true);
      Cookies.set("usertoken", token, {
        expires: 7,
      });
    }
  }

  function logout(): void {
    setUserInfo({
      token: "",
      fullName: "",
      mobile: 0,
      userRoll: [],
      id: null,
    });
    setIsLogged(false);
    Cookies.remove("usertoken");
  }

  function checkCookie(): void {
    if (Cookies.get("usertoken")) {
      CheckLoginInfoAPI().then((value) => {
        if (value.status == -1) {
          toast.error("کاربری با این مشخصات یافت نشد.");
          Cookies.remove("usertoken");

          return "";
        }
        let userRoll: number[] = [];
        value.userinfo.user_rolls.map((item: { value: any }) => {
          userRoll.push(parseInt(item.value));
        });

        login(
          value.data.usertoken,
          value.userinfo.fullname,
          value.userinfo.mobile,
          [...userRoll],
          value.userinfo.id
        );
        setIsChecked(true);
      });
    } else {
      setUserInfo({
        token: "",
        fullName: "",
        mobile: 0,
        userRoll: [],
        id: null,
      });
      setIsChecked(true);
    }
  }

  return (
    <>
      <AuthenticationContext.Provider
        value={{
          login,
          userInfo,
          isLogged,
          isChecked,
          logout,
        }}
      >
        {isChecked ? children : <Loader />}
      </AuthenticationContext.Provider>
    </>
  );
}
